import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Creatable from "react-select/creatable";

const AddTKCSOrderDetails = ({ size, getData, order_id, party_name }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [product, setProduct] = useState([]);
  const [productName, setProductName] = useState([]);
  const [circle, setCircle] = useState([]);
  const [circleName, setCircleName] = useState("");
  const [circleRate, setCircleRate] = useState([]);
  const [rowAddData, setRowAddData] = useState({
    circle: "",
    product_name: "",
    po_qty: "",
    gst_percent: 0,
    tkcs_rate: 0,
  });

  function resetFileds() {
    setRowAddData({
      circle: "",
      product_name: "",
      po_qty: "",
      gst_percent: 0,
      tkcs_rate: 0,
    });

    setProduct([]);
    setProductName("");
    setCircleName("");
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleCircleChange = (e) => {
    if (e) {
      setCircleName(e.value);
    } else {
      setCircleName("");
    }
    // setCircleName(e.target.value);
  };
  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setCircle([...circle, newOption]); // Add the new option to the list
    setCircleName(inputValue); // Set the new value
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { circle, po_qty, gst_percent, tkcs_rate } = rowAddData;

    let BASE_URL =
      SERVER_URL + `/api/private-order/private-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        private_order_id: order_id,
        circle: circleName,
        product_name: productName,
        po_qty,
        rate: tkcs_rate,
        gst_percent,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      setTimeout(() => {
        resetFileds();
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const handleProductChange = (e) => {
    setProductName(e.target.value);
  };

  const getCircle = async () => {
    const BASE_URL = SERVER_URL + `/api/rate-list/circle-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      if (result.data?.length > 0) {
        const combinedData = result.data?.map((item) => ({
          value: item.circle,
          label: item.circle,
        }));
        setCircle(combinedData);
      }
    } else {
      setCircle([]);
    }
  };
  useEffect(() => {
    getCircle();
  }, []);

  const getCircleRate = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/tkcs-rate/drop-tkcs-rate/${user_id}?party_name=${encodeURIComponent(
        party_name
      )}&product_name=${productName}&location=${encodeURIComponent(
        circleName
      )}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCircleRate(result.data);
    } else {
      setCircleRate(null);
    }
  };
  useEffect(() => {
    if (party_name && productName && circleName) {
      getCircleRate();
    }
  }, [productName, productName, circle]);

  useEffect(() => {
    if (circleRate) {
      setRowAddData({ ...rowAddData, tkcs_rate: circleRate.tkcs_rate });
    } else {
      setRowAddData({ ...rowAddData, tkcs_rate: 0 });
    }
  }, [circleRate]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add TKCS Order Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="po_qty">
                              Offer Quantity For Inspection
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              name="po_qty"
                              required
                              id="po_qty"
                              placeholder="Offer Quantity For Inspection"
                              value={rowAddData.po_qty}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle">Circle</label>
                            <Creatable
                              placeholder="Select or add circle"
                              onChange={handleCircleChange}
                              onCreateOption={handleCreateOption}
                              options={circle}
                              isSearchable
                              isClearable
                              value={
                                circle.find(
                                  (item) => item.value === circleName
                                ) || null
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor={`product`}>Size</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleProductChange}
                              name="product_name"
                              required
                              value={productName}
                              id={`product`}
                            >
                              <option value="">Select Product (All)</option>
                              {size &&
                                size?.length > 0 &&
                                size?.map((item, id) => {
                                  return (
                                    <option value={item.size} key={id}>
                                      {`${item.size}`}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="tkcs_rate"
                              pattern="[0-9]*"
                              id="rate"
                              required
                              placeholder="Rate"
                              value={rowAddData.tkcs_rate}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="gst">GST %</label>
                            <input
                              type="number"
                              className="form-control"
                              name="gst_percent"
                              min="0"
                              max="100"
                              title="Please enter number between 0-100"
                              id="gst"
                              required
                              placeholder="GST %"
                              value={rowAddData.gst_percent}
                              onChange={handleChange}
                              autoComplete="off"
                            />
                          </div>
                        </div>

                        {/* <span className="input-group-append ml-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            // onClick={handleAddFields}
                          >
                            Add More
                          </button>
                        </span> */}
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddTKCSOrderDetails;
